import React from 'react';
import List from '../cruds/List';
import ExpandableTable from '../components/container/ExpandableTable';
import { Column } from '../components/container/Table';
import OutputValue from '../components/output/OutputValue';
import MainContainer from '../components/MainContainer';
import { dateTimeFormatter } from '../functions/textFormatter';
import './Logs.css';

const LogDetail = (data) => (
  <div style={{ textAlign: 'left' }}>
    <ul>
      {data.map((d, i) => <li key={i}>{d}</li>)}
    </ul>
  </div>
);

const filtersValidation = (filters, name) => {
  const { from, to } = filters;
  if (name === 'from' && from && to && from.isAfter(to)) {
    filters.to = from;
  }

  if (name === 'to' && from && to && to.isBefore(from)) {
    filters.from = to;
  }
};

const Logs = props => {
  const filters = [
    { name: 'from', placeholder: 'logs.from', type: 'date' },
    { name: 'to', placeholder: 'logs.to', type: 'date' },
    { name: 'fullSearch', placeholder: 'logs.description' },
  ];

  const expand = LogDetail;

  const table = <ExpandableTable expand={expand} expandProperty="details">
                  <Column label="logs.username" orderingName="USER">
                    <OutputValue name="username" />
                  </Column>
                  <Column label="logs.timestamp" orderingName="TIMESTAMP">
                    <OutputValue name="timestamp" formatter={dateTimeFormatter} />
                  </Column>
                  <Column label="logs.description" orderingName="DESCRIPTION">
                    <OutputValue name="description" />
                  </Column>
                </ExpandableTable>;

  return <MainContainer>
            <List crudClassName="Logs"
                title="logs.title"
                entityName="logs"
                entityRoute="logs"
                component={table}
                filters={filters}
                filtersValidation={filtersValidation}
                defaultOrdering="TIMESTAMP"
                defaultAsc={false}
                hideAddButton={true}
            />
         </MainContainer>;
};

export default Logs;



// WEBPACK FOOTER //
// ./src/main/pages/Logs.js